import { render } from "./2_planta.vue?vue&type=template&id=38ebbf96&scoped=true"
import script from "./2_planta.vue?vue&type=script&lang=js"
export * from "./2_planta.vue?vue&type=script&lang=js"

import "./2_planta.vue?vue&type=style&index=0&id=38ebbf96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ebbf96"]])

export default __exports__